/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ scope: NonNullable<unknown>, target: NonNullable<unknown> }} Disabled_Websites_Disabled_Target_MessageInputs */

const en_disabled_websites_disabled_target_message = /** @type {(inputs: Disabled_Websites_Disabled_Target_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.scope === "domain") return /** @type {LocalizedString} */ (`Domain ${i?.target} has been disabled`);
	return /** @type {LocalizedString} */ (`Page ${i?.target} has been disabled`)
	
};

const es_disabled_websites_disabled_target_message = /** @type {(inputs: Disabled_Websites_Disabled_Target_MessageInputs) => LocalizedString} */ (i) => {
	if (i?.scope === "domain") return /** @type {LocalizedString} */ (`El dominio ${i?.target} ha sido deshabilitado`);
	return /** @type {LocalizedString} */ (`La página ${i?.target} ha sido deshabilitada`)
	
};

/**
* | scope | output |
* | --- | --- |
* | "domain" | "Domain {target} has been disabled" |
* | * | "Page {target} has been disabled" |
*
* @param {Disabled_Websites_Disabled_Target_MessageInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const disabled_websites_disabled_target_message = /** @type {((inputs: Disabled_Websites_Disabled_Target_MessageInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Disabled_Websites_Disabled_Target_MessageInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_disabled_websites_disabled_target_message(inputs)
	return en_disabled_websites_disabled_target_message(inputs)
});